export const peerIdSymbol = Symbol.for('@libp2p/peer-id');
export function isPeerId(other) {
    return other != null && Boolean(other[peerIdSymbol]);
}
//# sourceMappingURL=index.js.map